export const BUCKET_NAME = 'unity-61a0c';
export const ACCESS_KEY_ID = 'AKIA2XQXPQIQYDG2SFZL';
export const SECRET_ACCESS_KEY = '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';
